import { render, staticRenderFns } from "./OrdreEixidaEdit_new.vue?vue&type=template&id=5953091e&scoped=true"
import script from "./OrdreEixidaEdit_new.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaEdit_new.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaEdit_new.vue?vue&type=style&index=0&id=5953091e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953091e",
  null
  
)

export default component.exports